// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3e5TX","calendarButtons":"ClockData_calendarButtons__1Obma"};